import SpinnerIcon from '@pelckmans/elementis/icons/spinner';

export type LoadingText = { title: string; p1: string; p2: string };

export function ExerciseLoading({ loadingText }: { loadingText: LoadingText }) {
  return (
    <div className="exercise-container">
      <div className="content">
        <SpinnerIcon data-testid="spinner" className="loading-icon" size="xl" />
        <div className="body">
          <h1 className="title">{loadingText.title}</h1>
          <div>
            <p>{loadingText.p1}</p>
            <p>{loadingText.p2}</p>
          </div>
        </div>
      </div>
    </div>
  );
}
